import settings from '@config/settings'
import { GuardianLogo as LogoImage } from '@images'
import cn from 'classnames'
import './GuardianLogo.scss'

interface Props {
  autoWidth?: boolean
}

function GuardianLogo({ autoWidth = false }: Props) {
  return (
    <div className={cn('guardian-logo-wrapper', { 'auto-width': autoWidth })}>
      <a href={settings.landingPageUrl}>
        <img src={LogoImage} alt='Logo' />
      </a>
    </div>
  )
}

export default GuardianLogo
